import React, { Component } from "react";
import { connect } from 'react-redux';
import * as url from '../../../utils/url';
import axios from '../../../axios';
import * as actionCreators from '../../../modules/actions/index';
import MapSexualOrientation from '../../../components/OrganizationSetup/MapSexualOrientation/MapSexualOrientation';
import EnterpriseBreadcrumb from '../../../components/EnterpriseBreadcrumb/EnterpriseBreadcrumb';

class MapSexualOrientationManagement extends Component {
  // constructor(props) {
  //   super(props);
  // }

  componentDidMount() {
    window.scrollTo(0, 0);
    const {organizationId} = this.props.user;
    console.log("did mount management")
    axios.get(url.getExistingMappings(organizationId._id)).then(({data}) => {
      const payload = data.data;
      console.log(payload)
      const {sexualOrientation} = payload.mapping;
      if(sexualOrientation.columnName) {
        this.props.onMatchColumn(sexualOrientation.columnName);
      }
      const sexualOrientationData = sexualOrientation.data;
      let allMapping = []
      sexualOrientationData.forEach((c) => {
        const mapping = c.values.map((v) => {
          return {
            value : v,
            column : {
              label : c.reference.name,
              value : c.reference._id
            }
          }
        })
        allMapping = allMapping.concat(mapping);
      })
      this.props.saveAllSexualOrientationMapping(allMapping);
    })
  }

  componentWillUnmount() {
    this.props.resetMapSexualOrientationStep();
  }

  handleFileUpload = (columns, data, file) => {
    console.log(columns, data, file)
    this.props.onFileDataProcessed(columns, data, file);
  }

  handleMatchColumn = (matchedColumn) => {
    this.props.onMatchColumn(matchedColumn);
  }

  handleSkipMapping = () => {
    // console.log('Skip performance mapping');
  }

  render() {
    console.log(this.props)
    return (
      <div className="mt60">
      <EnterpriseBreadcrumb 
        linkText="Enterprise Management" 
        link="/home/enterprise-info" 
        activeText="Map Sexual Orientation"
        {...this.props}
        />
      <MapSexualOrientation 
        onProcessedFileUploadData={this.handleFileUpload}
        onSkipEthnicityMapping={this.handleSkipMapping}
        isRepeatFlow={true}
        {...this.props}/>
      </div>
    );
  }
}

const mapStateToProps = state => {
  console.log(state)
  return {
    user: state.user.profile,
    mapSexualOrientation : state.mapping.sexualOrientation
  }
}

const mapDispatchToProps = dispatch => {
	return {
    resetMapSexualOrientationStep: () => dispatch(actionCreators.resetMapSexualOrientationStep()),
    nextStep: () => dispatch(actionCreators.mapSexualOrientationNextStep()),
    goBack : () => dispatch(actionCreators.mapSexualOrientationGoBack()),
    reset : () => dispatch(actionCreators.resetSexualOrientation()),
    saveAllSexualOrientationMapping : (o,s) => dispatch(actionCreators.saveAllSexualOrientationMapping(o,s)),
    onFileDataProcessed: (c,d,f) => dispatch(actionCreators.mapSexualOrientationUploadFileSuccess(c,d,f)),
    onMatchColumn: data => dispatch(actionCreators.mapSexualOrientationMatchColumnSuccess(data))
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(MapSexualOrientationManagement);